//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "IntegrationSettings",
	props: {
		settings: Object
	},
	watch: {
		settings: function settings(newVal, oldVal) {
			if (newVal != oldVal) {
				var self = this;
				this.integrationDataLoading = true;
				if (newVal) {
					self.data = newVal;
					self.data.nestio = false;
					if (self.data.nestio_id) {
						self.data.nestio = true;
					}
					this.nestioSendFull = self.data.general_settings && self.data.general_settings.nestio_send_full;
					this.useNestio = self.data.general_settings && self.data.general_settings.use_nestio;
				}
			}
		}
	},
	data: function data() {
		return {
			modalName: 'integrations',
			editing: false,
			nestioSendFull: false,
			useNestio: false,
			integrationDataLoading: false,
			data: {
				bluemoon_serial_number: '',
				bluemoon_id: '',
				bluemoon_property_username: '',
				bluemoon_property_password: '',
				shift4_auth_token: '',
				dwolla_account: '',
				nestio: false,
				nestio_id: '',
				nestio_send_feed: false,
				nestio_community_id: '',
				place_pay_id: '',
				use_placepay_ach: '',
				use_placepay_cc: '',
				use_dwolla_ach: '',
				use_shift4_cc: ''
			},
			canDo: false,
			adminRoles: ['super-admin', 'corporate-admin']
		};
	},
	mounted: function mounted() {
		var _this = this;

		Event.$on('integrations', function () {
			Event.$emit('open-slide', _this.modalName);
		});

		Event.$on('close-slide', function () {
			_this.editing = false;
		});
		this.canDo = this.adminRoles.includes(window.validator.role());
	},

	methods: {
		cancel: function cancel() {
			Event.$emit('close-slide', this.modalName);
		},
		togglePlacePayCC: function togglePlacePayCC() {
			if (this.data.use_placepay_cc === true) {
				this.data.use_placepay_cc = 1;
				this.data.use_shift4_cc = 0;
			}
		},
		toggleShift4CC: function toggleShift4CC() {
			if (this.data.use_shift4_cc === true) {
				this.data.use_shift4_cc = 1;
				this.data.use_placepay_cc = 0;
			}
		},
		togglePlacePayACH: function togglePlacePayACH() {
			if (this.data.use_placepay_ach === true) {
				this.data.use_placepay_ach = 1;
				this.data.use_dwolla_ach = 0;
			}
		},
		toggleDwollaACH: function toggleDwollaACH() {
			if (this.data.use_dwolla_ach === true) {
				this.data.use_dwolla_ach = 1;
				this.data.use_placepay_ach = 0;
			}
		},
		changeACH: function changeACH(value) {
			this.data.use_dwolla_ach = 0;
			this.data.use_placepay_ach = 0;
			this.data.use_quext_pay_ach = 0;
			if (value == 'dwolla') {
				this.data.use_dwolla_ach = 1;
			} else if (value == 'placepay') {
				this.data.use_placepay_ach = 1;
			} else if (value == 'quextpay') {
				this.data.use_quext_pay_ach = 1;
			}
		},
		changeCC: function changeCC(value) {
			this.data.use_shift4_cc = 0;
			this.data.use_placepay_cc = 0;
			this.data.use_quext_pay_cc = 0;
			if (value == 'shift4') {
				this.data.use_shift4_cc = 1;
			} else if (value == 'placepay') {
				this.data.use_placepay_cc = 1;
			} else if (value == 'quextpay') {
				this.data.use_quext_pay_cc = 1;
			}
		},
		save: function save() {
			var _this2 = this;

			this.data.nestio_send_full = this.nestioSendFull;
			this.data.use_nestio = this.useNestio ? 1 : 0;
			axios.post('/prototype/properties/' + this.$store.state.selectedProperty + "/settings", {
				data: this.data
			}).then(function (response) {
				_this2.data = response.data;
				_this2.nestioSendFull = response.data.general_settings && response.data.general_settings.nestio_send_full;
				_this2.useNestio = response.data.general_settings && response.data.general_settings.use_nestio;
			}).then(function (response) {
				Event.$emit('close-slide', _this2.modalName);
			}).then(function (response) {
				_this2.$snotify.success("Changes saved successfully.");
			});
		},
		flushCache: function flushCache() {
			axios.post('/api/flush-portal-cache');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/IntegrationSettings.vue
// module id = vcPs
// module chunks = 0 1